import script from "./ThresholdSettingsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ThresholdSettingsComponent.vue?vue&type=script&setup=true&lang=js"

import "./ThresholdSettingsComponent.vue?vue&type=style&index=0&id=69c8a19e&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebasedevdemo\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69c8a19e"]])

export default __exports__